import Component from '../core/Component'
import { queryAll } from '../utils/dom'

export const STATUS = {
    MAX: 'is-max'
}

export default class FormTrainingRating extends Component {

    constructor(element) {
        super(element)

        this.ref = {
            cloneTarget: null,
            cloneTemplate: null,
            cloneAdd: null,
            cloneSelect: null,
            cloneGroup: null
        }

        this.limit = 0
        this.counter = -1
    }

    prepare() {
        if (this.ref.cloneAdd && this.ref.cloneTarget && this.ref.cloneTemplate) {
            this.ref.cloneAdd.addEventListener('click', ::this.handleCloneClick)
            this.ref.cloneTarget.addEventListener('change', ::this.handleChange)
            this.limit = queryAll('option', this.ref.cloneSelect).filter(option => option.value).length
            this.checkSelects()
        }
    }

    handleCloneRemove(item) {
        item.parentNode.removeChild(item)
        this.checkSelects()
    }

    handleCloneClick(event) {
        event.preventDefault()

        const item = this.ref.cloneTemplate.cloneNode(true)
        item.innerHTML = item.innerHTML.replace(/\[template\]/gi, `[${this.counter}]`)
        this.counter--
        queryAll('option', item).forEach(option => option.hidden = false)
        queryAll('textarea, select', item).forEach(input => input.value = '')

        item.querySelector('[data-ref="cloneRemove"]').addEventListener('click', event => {
            event.preventDefault()
            this.handleCloneRemove(item)
        })

        this.ref.cloneTarget.appendChild(item)

        this.checkSelects()

        queryAll('select', item).forEach(select => {
            select.value = queryAll('option', select).filter(option => !option.hidden)[0].value
        })

    }

    handleChange(event) {
        this.checkSelects()
    }

    checkSelects() {
        const selects = queryAll('[data-ref="cloneSelect"]', this.ref.cloneTarget)
        const selectedValues = selects.map(select => select.value).filter(value => value)
        selects.forEach(select => {
            const value = select.value
            queryAll('option', select).forEach(option => {
                option.hidden = option.value !== value && selectedValues.indexOf(option.value) > -1
            })
        })

        this.ref.cloneGroup.classList.toggle(STATUS.MAX, selects.length === this.limit)
    }

}